const NotFoundIcon = () => (
    <svg
        aria-labelledby="notFoundIcon"
        data-testid="icon"
        width="73"
        height="63"
        viewBox="0 0 73 63"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <title id="notFoundIcon">Not Found</title>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 63L36.5 0L73 63H0ZM61.4861 56.3684L36.5002 13.23L11.5143 56.3684H61.4861ZM39.8184 46.4209H33.1821V53.0525H39.8184V46.4209ZM33.1821 26.5265H39.8184V39.7896H33.1821V26.5265Z"
            fill="#0559AD"
        />
    </svg>
);

export default NotFoundIcon;
